/**
 * Collection Page - Filter, Search, Sort & AJAX Pagination
 * Works with Shopify native filters and Search & Discovery app
 */
(function() {
  'use strict';

  var section = document.querySelector('[data-collection-section]');
  if (!section) return;

  // Elements
  var grid = section.querySelector('[data-product-grid]');
  var skeletons = section.querySelector('[data-skeletons]');
  var pagination = section.querySelector('[data-pagination]');
  var prevBtn = section.querySelector('[data-page-prev]');
  var nextBtn = section.querySelector('[data-page-next]');
  var pageNumbers = section.querySelector('[data-page-numbers]');
  var currentPageEl = section.querySelector('[data-current-page]');
  var totalPagesEl = section.querySelector('[data-total-pages]');
  var viewingEl = section.querySelector('[data-viewing]');
  var productCountEl = section.querySelector('[data-product-count]');

  // Search elements
  var searchInput = section.querySelector('[data-product-search]');
  var searchClear = section.querySelector('[data-search-clear]');
  var noResultsEl = section.querySelector('[data-no-results]');
  var searchTermEl = section.querySelector('[data-search-term]');
  var clearSearchBtn = section.querySelector('[data-clear-search]');

  // Filter elements
  var filterToggle = document.querySelector('[data-filter-toggle]');
  var filterDrawer = document.querySelector('[data-filter-drawer]');
  var filterOverlay = document.querySelector('[data-filter-overlay]');
  var filterClose = document.querySelector('[data-filter-close]');
  var sortSelect = section.querySelector('[data-sort-select]');
  var filterGroups = document.querySelectorAll('[data-filter-group]');
  var clearAllBtn = section.querySelector('[data-clear-filters]');
  var applyBtn = document.querySelector('[data-apply-filters]');
  var resetBtn = document.querySelector('[data-reset-filters]');

  // View toggle elements
  var viewToggle = section.querySelector('[data-view-toggle]');
  var viewBtns = viewToggle ? viewToggle.querySelectorAll('[data-view]') : [];

  var currentPage = 1;
  var totalPages = parseInt(totalPagesEl?.textContent || '1');
  var isLoading = false;
  var searchTimeout = null;
  var collectionUrl = section.dataset.collectionUrl || window.location.pathname;

  // ========================================
  // Loading States
  // ========================================

  function showLoading() {
    if (grid) grid.style.display = 'none';
    if (skeletons) {
      skeletons.style.display = 'grid';
    }
    isLoading = true;
  }

  function hideLoading() {
    if (skeletons) skeletons.style.display = 'none';
    if (grid) {
      grid.style.display = 'grid';
    }
    isLoading = false;
  }

  // ========================================
  // AJAX Pagination
  // ========================================

  function updatePaginationUI(page) {
    currentPage = page;

    if (currentPageEl) currentPageEl.textContent = page;

    if (prevBtn) prevBtn.disabled = page <= 1;
    if (nextBtn) nextBtn.disabled = page >= totalPages;

    if (pageNumbers) {
      var buttons = pageNumbers.querySelectorAll('[data-page]');
      buttons.forEach(function(btn) {
        var btnPage = parseInt(btn.dataset.page);
        btn.classList.toggle('is-active', btnPage === page);
        btn.setAttribute('aria-current', btnPage === page ? 'page' : 'false');
      });
    }

    // Update URL without reload
    var url = new URL(window.location.href);
    if (page > 1) {
      url.searchParams.set('page', page);
    } else {
      url.searchParams.delete('page');
    }
    history.pushState({ page: page }, '', url.toString());
  }

  function loadPage(page) {
    if (isLoading || page < 1 || page > totalPages || page === currentPage) return;

    showLoading();

    var url = new URL(window.location.href);
    url.searchParams.set('page', page);

    fetch(url.toString(), {
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    .then(function(response) {
      return response.text();
    })
    .then(function(html) {
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html');
      var newGrid = doc.querySelector('[data-product-grid]');
      var newPagination = doc.querySelector('[data-pagination]');
      var newViewing = doc.querySelector('[data-viewing]');

      if (newGrid && grid) {
        grid.innerHTML = newGrid.innerHTML;
      }

      if (newPagination && pagination) {
        var newPageNumbers = newPagination.querySelector('[data-page-numbers]');
        if (newPageNumbers && pageNumbers) {
          pageNumbers.innerHTML = newPageNumbers.innerHTML;
          bindPageNumberClicks();
        }
      }

      if (newViewing && viewingEl) {
        viewingEl.textContent = newViewing.textContent;
      }

      updatePaginationUI(page);
      hideLoading();

      section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    })
    .catch(function(error) {
      console.error('Error loading page:', error);
      hideLoading();
    });
  }

  function bindPageNumberClicks() {
    var buttons = section.querySelectorAll('[data-page]');
    buttons.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var page = parseInt(this.dataset.page);
        loadPage(page);
      });
    });
  }

  // Pagination event listeners
  if (prevBtn) {
    prevBtn.addEventListener('click', function() {
      loadPage(currentPage - 1);
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', function() {
      loadPage(currentPage + 1);
    });
  }

  bindPageNumberClicks();

  // Handle browser back/forward
  window.addEventListener('popstate', function(e) {
    if (e.state && e.state.page) {
      loadPage(e.state.page);
    } else {
      var url = new URL(window.location.href);
      var page = parseInt(url.searchParams.get('page')) || 1;
      if (page !== currentPage) {
        loadPage(page);
      }
    }
  });

  // Set initial page from URL
  var initialUrl = new URL(window.location.href);
  var initialPage = parseInt(initialUrl.searchParams.get('page')) || 1;
  if (initialPage > 1) {
    currentPage = initialPage;
    updatePaginationUI(initialPage);
  }

  // ========================================
  // Client-side Search
  // ========================================

  function matchSearch(text, searchTerm) {
    if (!searchTerm) return true;

    // Direct include check
    if (text.includes(searchTerm)) return true;

    // Split by common separators and check word starts
    var words = text.split(/[\s\/\-\_\|\,\.]+/);
    for (var i = 0; i < words.length; i++) {
      if (words[i].startsWith(searchTerm)) return true;
    }

    return false;
  }

  function filterProducts(searchTerm) {
    var cards = grid.querySelectorAll('[data-product-card]');
    var visibleCount = 0;
    var term = searchTerm.toLowerCase().trim();

    cards.forEach(function(card) {
      var title = card.dataset.title || '';
      var vendor = card.dataset.vendor || '';
      var type = card.dataset.type || '';

      // Check all searchable fields
      var isMatch = matchSearch(title, term) ||
                    matchSearch(vendor, term) ||
                    matchSearch(type, term);

      if (isMatch) {
        card.classList.remove('is-hidden');
        visibleCount++;
      } else {
        card.classList.add('is-hidden');
      }
    });

    // Update count
    if (productCountEl) {
      productCountEl.textContent = visibleCount + ' ' + (visibleCount === 1 ? 'product' : 'products');
    }

    // Show/hide no results and pagination
    if (visibleCount === 0 && term) {
      if (noResultsEl) {
        noResultsEl.style.display = 'flex';
        if (searchTermEl) searchTermEl.textContent = searchTerm;
      }
      if (grid) grid.style.display = 'none';
      if (pagination) pagination.style.display = 'none';
    } else {
      if (noResultsEl) noResultsEl.style.display = 'none';
      if (grid) grid.style.display = 'grid';
      // Hide pagination when search is active (filtering client-side)
      if (pagination) {
        pagination.style.display = term ? 'none' : (totalPages > 1 ? 'flex' : 'none');
      }
    }
  }

  function clearSearch() {
    if (searchInput) {
      searchInput.value = '';
      filterProducts('');
    }
  }

  // Search input handler
  if (searchInput) {
    searchInput.addEventListener('input', function() {
      clearTimeout(searchTimeout);
      var value = this.value;

      searchTimeout = setTimeout(function() {
        filterProducts(value);
      }, 200);
    });
  }

  // Search clear buttons
  if (searchClear) {
    searchClear.addEventListener('click', clearSearch);
  }

  if (clearSearchBtn) {
    clearSearchBtn.addEventListener('click', clearSearch);
  }

  // ========================================
  // Filter Drawer
  // ========================================

  function openFilterDrawer() {
    if (filterDrawer) {
      filterDrawer.classList.add('is-open');
      filterOverlay?.classList.add('is-visible');
      document.body.style.overflow = 'hidden';
    }
  }

  function closeFilterDrawer() {
    if (filterDrawer) {
      filterDrawer.classList.remove('is-open');
      filterOverlay?.classList.remove('is-visible');
      document.body.style.overflow = '';
    }
  }

  if (filterToggle) {
    filterToggle.addEventListener('click', openFilterDrawer);
  }

  if (filterClose) {
    filterClose.addEventListener('click', closeFilterDrawer);
  }

  if (filterOverlay) {
    filterOverlay.addEventListener('click', closeFilterDrawer);
  }

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && filterDrawer?.classList.contains('is-open')) {
      closeFilterDrawer();
    }
  });

  // ========================================
  // Sorting (Shopify native)
  // ========================================

  if (sortSelect) {
    sortSelect.addEventListener('change', function() {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      url.searchParams.delete('page'); // Reset to page 1
      window.location.href = url.toString();
    });
  }

  // ========================================
  // Filter Groups Toggle
  // ========================================

  filterGroups.forEach(function(group) {
    var header = group.querySelector('[data-filter-group-header]');
    if (header) {
      header.addEventListener('click', function() {
        group.classList.toggle('is-collapsed');
      });
    }
  });

  // ========================================
  // Clear/Reset Filters
  // ========================================

  if (clearAllBtn) {
    clearAllBtn.addEventListener('click', function() {
      var url = new URL(window.location.href);
      var sortBy = url.searchParams.get('sort_by');
      url.search = '';
      if (sortBy) {
        url.searchParams.set('sort_by', sortBy);
      }
      window.location.href = url.toString();
    });
  }

  if (applyBtn) {
    applyBtn.addEventListener('click', function() {
      var form = filterDrawer?.querySelector('form');
      if (form) {
        form.submit();
      } else {
        closeFilterDrawer();
      }
    });
  }

  if (resetBtn) {
    resetBtn.addEventListener('click', function() {
      var checkboxes = filterDrawer?.querySelectorAll('input[type="checkbox"]');
      checkboxes?.forEach(function(cb) {
        cb.checked = false;
      });

      var priceInputs = filterDrawer?.querySelectorAll('.filter-price__input');
      priceInputs?.forEach(function(input) {
        input.value = '';
      });
    });
  }

  // Remove individual filter tag
  document.querySelectorAll('[data-remove-filter]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var filterKey = this.dataset.removeFilter;
      var filterValue = this.dataset.filterValue;
      var url = new URL(window.location.href);

      var currentValues = url.searchParams.getAll(filterKey);
      url.searchParams.delete(filterKey);

      currentValues.forEach(function(val) {
        if (val !== filterValue) {
          url.searchParams.append(filterKey, val);
        }
      });

      window.location.href = url.toString();
    });
  });

  // ========================================
  // View Toggle (Grid/List)
  // ========================================

  function setViewMode(mode) {
    if (!grid) return;

    if (mode === 'list') {
      grid.classList.add('is-list-view');
    } else {
      grid.classList.remove('is-list-view');
    }

    viewBtns.forEach(function(btn) {
      btn.classList.toggle('is-active', btn.dataset.view === mode);
    });

    try {
      localStorage.setItem('collection-view', mode);
    } catch (e) {}
  }

  // View toggle event listeners
  viewBtns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      setViewMode(this.dataset.view);
    });
  });

  // Apply saved view mode on page load
  (function() {
    try {
      var savedView = localStorage.getItem('collection-view');
      if (savedView === 'list' || savedView === 'grid') {
        setViewMode(savedView);
      }
    } catch (e) {}
  })();

})();
